import {
  DisplayProperties,
  Stipulation,
  Summary
} from '@com-delta-idp/mnx-skymiles-shared';
import { Tracker as TrackerUI } from '@com-delta-omnichannel/aura';
import {
  Benefits,
  EarnsSummary,
  MicroMoments,
  Onboarding,
  QuickLinks,
  SkyClubSpendTracker,
  Snapshot,
  Upgrades
} from '../../../features';
import { CardCarousel } from '../../../features/card-carousel/models/card-carousel.interfaces';
import { SkyClubTracker } from '../../../features/skyclub/models/skyclub.interfaces';
import { Earns } from '../../earns/models/earns.interfaces';

export interface OverviewPage {
  onboarding: Onboarding;
  microMoments: MicroMoments;
  header: string;
  tracker: Tracker;
  summary: Summary;
  status: Summary;
  cards: CardCarousel;
  quickLinks: QuickLinks;
  benefits: Benefits;
  snapshot: Snapshot;
  upgrades: Upgrades;
  earns: Earns;
  stipulation: Stipulation;
  earnsSummary: EarnsSummary;
  // TODO Make required once Skyclub Smart is ready
  skyclubTracker: SkyClubTracker;
  amexSkyClubTracker: SkyClubSpendTracker;
}

export interface Tracker extends TrackerUI, DisplayProperties {
  id?: string;
  educationalTitle: string;
}
